export const useConfig = () => {
  return useRuntimeConfig()
}
